"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numbersWithAbbreviates = void 0;
var numbersWithAbbreviates = function (value) {
    var kilo = 1000;
    var million = 1000000;
    var minKiloLength = 4;
    var maxKiloLength = 6;
    var valueLength = String(value).length;
    var label;
    if (valueLength < minKiloLength) {
        label = value;
    }
    else if (valueLength >= minKiloLength && valueLength <= maxKiloLength) {
        value = Math.round(value / kilo) * kilo;
        label = value / kilo + 'K';
    }
    else {
        value = Math.round(value / million) * million;
        label = value / million + 'M';
    }
    return {
        label: label,
        value: value,
    };
};
exports.numbersWithAbbreviates = numbersWithAbbreviates;
